import React from 'react';
import pinGray from './assets/pin_gray.png'
import rightArrow from './assets/right_arrow.png'
import {Alcoholcustomerv1VendingMachine} from "./typescript-axios";



interface Props {
    vendingMachine: Alcoholcustomerv1VendingMachine
    onClick: Function
}

function VendingMachineListItem(props: Props) {
    return (
        <div className={`container mb-2 border-bottom`} onClick={()=>{props.onClick()}}>
            <div className={""}>
                <h5 className={"machineListItemHeader"}>{(props.vendingMachine.name)}</h5>
            </div>
            <div className={"d-flex align-items-center"}>
                <div className={"p-2"}>
                    <img src={pinGray} alt=""/>
                </div>
                <div className={"p-2"}>
                    <span className={"machineListItemAddress"}>{props.vendingMachine.location}</span>
                </div>
                <div className={"p-2 ms-auto"}>
                    <img src={rightArrow} alt=""/>
                </div>
            </div>
        </div>
    );
}

export default VendingMachineListItem;